import {skipToken} from '@reduxjs/toolkit/query';

import {isNotNil} from 'ramda';
import {isNotNilOrEmpty} from 'ramda-adjunct';

import {useGetServiceCaseDetailBootstrapQuery} from '@dms/api/workshop';

export function useServiceCaseDetailBootstrap(serviceCaseId: string) {
  const bootstrapQuery = useGetServiceCaseDetailBootstrapQuery(
    isNotNilOrEmpty(serviceCaseId) ? {serviceCaseId} : skipToken
  );

  // `currentData` (never `data`): an in-place serviceCaseId change (SC→SC navigation keeps
  // the page mounted) must re-close the gate and blank the direct reads — `data` would keep
  // serving case A's payload while case B fetches, so every skip-gated hook would fire for B
  // before B's seeds land and A's slices would render under B's URL.
  const bootstrap = bootstrapQuery.currentData;

  // Settled = the seeds for the current serviceCaseId are in the granular caches (or the
  // bootstrap failed / returned nothing and there is nothing to wait for). Stays true during
  // same-key tag-driven refetches while a non-null payload is cached (currentData persists);
  // after a degenerate 200-with-null-body it briefly re-closes during such a refetch, which
  // is harmless — nothing was rendered from that payload anyway. Re-closes on arg change.
  const isBootstrapSettled = !bootstrapQuery.isFetching || isNotNil(bootstrapQuery.currentData);

  return {bootstrap, isBootstrapSettled, isBootstrapLoading: bootstrapQuery.isLoading};
}
